/**
 * WatchlistPage — раздел «Вотчлист». Оболочка/тема — в общем Header (App.tsx).
 * Логика/данные — живые из /market/strangle-analysis; формулы/пороги/API не менялись.
 */

import { ScoutWatchlist } from "../components/ScoutWatchlist";

export function WatchlistPage() {
  return <ScoutWatchlist />;
}
